import { responseStatus } from '../constants';
import { ApiPaths } from '../helpers/api';
import { ThongBaoTrangLogin } from '../models/home/Home';
import { Setting } from '../models/setting/Setting';
import intance from '../utils/axios';

export const layDanhSachThongBaoTaiTrangLogin = async () => {
    var data: Array<ThongBaoTrangLogin> = [];
    await intance.get(ApiPaths.home.LayDSThongBaoTaiTrangLogin)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const layCauHinhSinhNhatQuy = async () => {
    var rs: any;
    await intance.get(ApiPaths.home.LayCauHinhSinhNhatQuy)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};